
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useI18n } from "src/utils/lni18n";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import courseService, { oneThemeAtom } from "../CourseService";
import { debouncer } from "src/utils/debouncer";
import { urlService } from "src/services/NavService";
import { useAtom } from "jotai";
import { useAlert } from "src/components/Modalservice/UseAlert";
import { useConfirm } from "src/components/Modalservice/UseConfirm";


const EditThemeMeta = () => {
    const { courseId, themeId } = useParams();
    
    if (!courseId || !themeId) {
        return null;
    }
    
    return <EditThemeMetaInner courseId={courseId} themeId={themeId} />;
};

const EditThemeMetaInner = ({ courseId, themeId }: { courseId: string, themeId: string }) => {

    const debounce = useRef<debouncer | undefined>(undefined);
    const { languageService: t } = useI18n();
    const navigate = useNavigate();
    const { state } = useLocation();
    const alert = useAlert();
    const confirm = useConfirm();



    const [theme] = useAtom(useMemo(() => oneThemeAtom(courseId!, themeId!), [courseId, themeId]));

    const [themeName, setThemeName] = useState(theme?.Name ?? "")

    const saveData = useCallback((name: string, id: string, currentCourseId: string) => {
        courseService.updateThemeName(currentCourseId, id, name);
    }, []);

    useEffect(() => {
        debounce.current = new debouncer(saveData, 500);
        return () => debounce.current?.flush();
    }, [saveData])

    useEffect(() => {
        setThemeName(theme?.Name ?? "");
    }, [theme])

    const updateThemeName = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        if (theme) {
            const text = e.currentTarget.value;
            setThemeName(text);
            debounce.current && debounce.current.debounce(text, theme.Id, courseId);
        }
    }, [theme, courseId]);

    function deleteTheme(): void {

        confirm("md", t.getText("delete"),
            <div className="preserve-white">{t.getText("delete_theme_confirm")}</div>)
        .then(async (res) => {
            if (res) {
                await courseService.deleteTheme(courseId!, themeId!);
                navigate(urlService.urlToCourse(courseId!));
            }
        }).catch((e: Error) => { });

    }


    const downloadLectures = async () => {
        const text = await courseService.downloadThemeLectures(courseId!, themeId!);
        if (text) {
            await alert("md", t.getText("lectures"), <div className="preserve-white">{text}</div>);
        }
    }

    return (<>

        <div className="row">
            <div className="col-sm-12 col-md-8 position-relative">
                <div className="">
                    <div className="form-group flex-grow-1">
                        <label>{t.getText("name")}</label>
                        <input disabled={state?.readOnly} type="text" className="form-control" value={themeName ?? ""} onChange={updateThemeName} />
                    </div>

                    {!state?.readOnly &&
                        <button onClick={deleteTheme} className="btn btn-warning">{t.getText("delete")}</button>
                    }
                </div>

                {!state?.readOnly &&
                    <div className="form-group mt-5">

                        <div className="mt-3 mb-4">
                            <h3>{t.getText("lectures")}</h3>
                            <div className="d-flex align-items-center">
                                <div className="preserve-white mr-5">
                                    {t.getText("download.lectures")}
                                </div>
                                <div>
                                    <button onClick={downloadLectures} className="btn btn-small btn-primary">{t.getText("download")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </div>
    </>
    )
}

export default EditThemeMeta;
